export default __webpack_public_path__ + "static/media/Brow_1_C4.30564fd4.svg";